export const EVENT_CHAT = "EVENT_CHAT";
///////////////////////////////
export const CLEAR_CONTACT_EVENT = "CLEAR_CONTACT_EVENT";
export const UPDATE_CONTACT_EVENT = "UPDATE_CONTACT_EVENT";
//////////////////////////////
export const UPDATE_BADGET_NAVBAR_SUCCESS = "UPDATE_BADGET_NAVBAR_SUCCESS";
export const UPDATE_BADGET_NAVBAR_FAILED = "UPDATE_BADGET_NAVBAR_FAILED";
export const RECEIVE_EVENT_NOTIFICATION = "RECEIVE_EVENT_NOTIFICATION";

export const LOGOUT = "LOGOUT";